var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgcard"},[_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.list),function(item,index){return _c('el-col',{key:index,attrs:{"span":8}},[_c('div',{staticClass:"imgcard-container"},[_c('img',{attrs:{"src":"item.photo1","alt":""}})])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0aa34abe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/imgCard.vue
// module id = null
// module chunks = 